import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { NotificationFilterType, NotificationScheduleType } from 'webapp/enums/notifications';

import type { Scorecard } from 'webapp/models-custom';
import NotificationBase from 'webapp/models-custom/notification/base';

export default class NotificationScorecard extends NotificationBase {
	@service('model-manager/scorecards')
	declare mmScorecardsService: Service.ModelManager.Scorecards;

	type = NotificationFilterType.SCORECARD;
	scheduleType = NotificationScheduleType.UPDATE;
	targetObject: Scorecard;
	typeColor = 'var(--databox-cyan-500)';
	typeIcon: IconName = 'Scorecard';
	override canToggle = false;

	constructor(model: Scorecard) {
		super();
		this.targetObject = model;
	}

	get title() {
		return this.targetObject.title;
	}

	get subtitleText() {
		return this.targetObject.usedMetricsText;
	}

	get isMine() {
		return this.targetObject.isActiveUserOwner;
	}

	override get canPreview() {
		return true;
	}

	get schedule() {
		return this.targetObject.schedule;
	}

	get frequency() {
		const frequency = this.mmNotificationsService.getFrequencyFromSchedule(this.schedule.type);
		return frequency ? [frequency] : [];
	}

	override get frequencySortProp() {
		return this.schedule.deliveryTimeLevel;
	}

	get frequencyTooltipTextTop() {
		const schedule = this.schedule;
		return `${schedule.typeText} ${schedule.timeText}`;
	}

	get createdBy() {
		return this.targetObject.createdByUser || null;
	}

	get createdOn() {
		return this.targetObject.created;
	}

	get deliveryTypes() {
		return this.targetObject.delivery;
	}

	get emailRecipients() {
		return this.targetObject.userIds;
	}

	get allRecipients() {
		return this.targetObject.mappedRecipients;
	}

	override get isToggleOn() {
		return this.targetObject.isActive;
	}

	delete() {
		// custom logic. if i see a "shared" scorecard where im not the owner, deleting "my" will just remove myself from the original
		void this.targetObject.deleteAndCatch();
	}

	override preview() {
		this.mmScorecardsService.openPreviewPopupFromModel(this.targetObject);
	}

	override toggle() {
		this.mmScorecardsService.toggleIsActive(this.targetObject);
	}
}
